import { FetchProfileImageResult, FetchProfileProps, useFetchProfileImage } from "./fetch.profile.images";
import { LoadingOr } from "@me8eon/async";
import { useAccessTokenFn } from "@me8eon/react_authentication";
import { useMemo } from "react";

type ProfileImageProps = {
    userId: string;
    altText?: string; // Optional alt text for the image
};

//Needs to be stable across renders so don't move
const disposeOnUnmount = (res: FetchProfileImageResult) => res.dispose();

function ProfileImageError({ error }: { error: string }): React.ReactElement {
    return <div>Custom Error loading profile image: {error}</div>;
    //We will replace with error icon after permission issues resolved. Chat with Hari
}

export function ProfileImage(props: ProfileImageProps) {
    const { altText = "Profile image", userId } = props;
    const token = useAccessTokenFn("profileImage");
    const fetchProfileImage = useFetchProfileImage();
    const userIdAndToken: FetchProfileProps = useMemo(() => ({ userId, token }), [userId, token]);
    return <LoadingOr input={userIdAndToken} kleisli={fetchProfileImage} onUnmount={disposeOnUnmount} error={ProfileImageError}>
        {({ imageUrl }) =>
            <img src={imageUrl} alt={altText} />}
    </LoadingOr>;
}
